import NavBarView from "./NavBarView";

/*
*   (전역) 하단 NavBar
*/
export default NavBarView;